export function FullPageLoader({ label = "Loading" }: { label?: string }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-paper px-6 text-ink">
      <div className="flex items-center gap-3 text-sm font-medium">
        <span className="h-2.5 w-2.5 animate-pulse rounded-full bg-pine" />
        {label}
      </div>
    </div>
  );
}
